module.exports = __webpack_public_path__ + "media/images/suceess-story5-d9114dffeb7a2488099bb59fb144dad9.jpg";